module.exports = __webpack_public_path__ + "static/media/the-creek-drank-the-cradle.898fa95b.jpg";